var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"},attrs:{"id":"ubie-banner","data-ubie-href":"https://sg.ubie.app/medical-institutions/drdanielwai","data-banner-type":"desktop-banner-m","data-is-responsive":""}})}
var staticRenderFns = []

export { render, staticRenderFns }